import { CoreEnums } from '@/utils/domain/constants';

export default {
  lazy: true,
  user: false,
  remote: true,
  showSearch: true,
  type: 'select',
  name: 'processId',
  label: 'global.text.process',
  locale: true,
  params: { filter: 'isActive eq true', select: 'id,name', orderBy: 'name' },
  // style: { maxWidth: isMobileOnly ? '100%' : 350 },
  apiRoute: 'process/allowed',
  labelInValue: false,
  nomenclature: true,
  allowClear: true,
  options: [],
  knownType: CoreEnums.FormFieldType.InternalEntity,
};
